import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IDmLoaiThuNhapHoc } from "../../../model/respone/category/IDmLoaiThuNhapHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import { loaiThuNhapHocApi } from "./../../../api/category/loaiThuNhapHocApi";
import {
  eDmLoaiThuNhapHocActionIds,
  IDmLoaiThuNhapHocActionTypes,
} from "./../../action-types/category/IDmLoaiThuNhapHocActions";
import { IDmLoaiThuNhapHocRequest } from "../../../model/request/category/dmLoaiThuNhapHocRequest";
import { IHeNganhChuyenNganhTheoDotNhapHoc } from "../../reducer-model/category/IDmLoaiThuNhapHocReducer";

export function* loaiThuNhapHocSaga(): any {
  yield takeLatest(eDmLoaiThuNhapHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmLoaiThuNhapHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmLoaiThuNhapHocActionIds.DELETE_START, deleteWorker);
  yield takeEvery(
    eDmLoaiThuNhapHocActionIds.DELETE_MANY_START,
    deleteManyWorker
  );
  yield takeLatest(
    eDmLoaiThuNhapHocActionIds.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START,
    loadHeNganhsWorker
  );
  yield takeEvery(
    eDmLoaiThuNhapHocActionIds.SAVE_MULTIPLE_START,
    insertMultipleWorker
  );
  yield takeLatest(
    eDmLoaiThuNhapHocActionIds.LOAD_THEO_DOT_START,
    loadByDotWorker
  );
}

function* loadWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: IBaseRespone = yield call(loaiThuNhapHocApi.SelectViewModelAll);
  if (res.is_success) {
    yield put(rootActions.category.loaiThuNhapHoc.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.loaiThuNhapHoc.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDmLoaiThuNhapHoc;
  if (payload.id_thu_chi_main > 0) {
    res = yield call(loaiThuNhapHocApi.Update, payload);
  } else {
    res = yield call(loaiThuNhapHocApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.loaiThuNhapHoc.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.loaiThuNhapHoc.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuNhapHocApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.loaiThuNhapHoc.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.loaiThuNhapHoc.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* deleteManyWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: number = yield call(
    loaiThuNhapHocApi.DeleteMany,
    action.payload as number[]
  );
  if (res > 0) {
    yield put(
      rootActions.category.loaiThuNhapHoc.DELETE_MANY_SUCCESS(undefined)
    );
  } else {
    yield put(rootActions.category.loaiThuNhapHoc.DELETE_MANY_ERROR("Có lỗi"));
  }
}

function* loadHeNganhsWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuNhapHocApi.SelectHeNganhsByDot,
    action.payload as IDmLoaiThuNhapHocRequest
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuNhapHoc.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS(
        res.data as IHeNganhChuyenNganhTheoDotNhapHoc[]
      )
    );
  } else {
    yield put(
      rootActions.category.loaiThuNhapHoc.LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR(
        "Có lỗi"
      )
    );
  }
}

function* insertMultipleWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuNhapHocApi.InsertMultiple,
    action.payload as IDmLoaiThuNhapHoc[]
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuNhapHoc.SAVE_MULTIPLE_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.category.loaiThuNhapHoc.SAVE_MULTIPLE_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
function* loadByDotWorker(action: IDmLoaiThuNhapHocActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuNhapHocApi.SelectByDot,
    action.payload as IDmLoaiThuNhapHocRequest
  );
  if (res.is_success) {
    yield put(
      rootActions.category.loaiThuNhapHoc.LOAD_THEO_DOT_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.category.loaiThuNhapHoc.LOAD_THEO_DOT_ERRR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
